import styled from 'styled-components';

export default styled.div`
	display: flex;
	padding: var(--spacing-small);
	gap: var(--spacing-medium);
	background-color: var(--neutrals-25);
	border-radius: var(--spacing-medium);
	justify-content: space-around;
	margin-top: auto;

	hr {
		--hr-color: var(--neutrals-700);
	}

	.motif-button {
		border-radius: var(--spacing-small);
		gap: var(--spacing-small);
		flex: 1;
		min-width: 0;
		&.motif-button.motif-text-alt-button,
		&.motif-button.motif-text-button {
			padding: 0 var(--spacing-x-large);
		}
		&.motif-text-button {
			cursor: default;
		}
		&.motif-text-alt-button {
			&:hover,
			&.active {
				border-radius: var(--spacing-small);
				background-color: var(--neutrals-100);
			}
		}
		& > .count {
			flex-shrink: 0;
		}
	}
`;
